import { render, staticRenderFns } from "./TaskParticipants.vue?vue&type=template&id=19694814&scoped=true"
import script from "./TaskParticipants.vue?vue&type=script&lang=js"
export * from "./TaskParticipants.vue?vue&type=script&lang=js"
import style0 from "./TaskParticipants.vue?vue&type=style&index=0&id=19694814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19694814",
  null
  
)

export default component.exports